import Button from 'components/Button/src/jsx/Button';
import PropTypes from 'prop-types';
import { useSso } from '../hooks/useSso';
import { stripHtmlTags } from '../utils/general';

export default function Sso({ getLabel, getRecaptchaToken, locale, region, setError, ssoGoogleUrl, ssoMicrosoftUrl }) {
	const { onGoogleSsoClick, onMicrosoftSsoClick } = useSso({
		consentText: stripHtmlTags(getLabel('registration_consent_text')),
		getRecaptchaToken,
		locale,
		region,
		setError,
		ssoGoogleUrl,
		ssoMicrosoftUrl,
	});

	return (
		<div className="trial__sso">
			<Button testId="sso-google" sso={true} ssoId="google" onClick={onGoogleSsoClick}>
				{getLabel('registration_sso_button_google')}
			</Button>
			<Button testId="sso-microsoft" sso={true} ssoId="microsoft" onClick={onMicrosoftSsoClick}>
				{getLabel('registration_sso_button_microsoft')}
			</Button>
			<p className="sso-consent-text" dangerouslySetInnerHTML={{ __html: getLabel('registration_consent_text') }} />
			{/* {error && <div className="trial__sso-error">{getLabel('sso_error_msg')[error]}</div>} */}
		</div>
	);
}

Sso.propTypes = {
	getLabel: PropTypes.func.isRequired,
	getRecaptchaToken: PropTypes.func.isRequired,
	locale: PropTypes.string,
	region: PropTypes.string,
	setError: PropTypes.func.isRequired,
	ssoGoogleUrl: PropTypes.string,
	ssoMicrosoftUrl: PropTypes.string,
};
